import { configureStore } from '@reduxjs/toolkit';
import establishmentAccessReducer from './establishmentAccessSlice';

export const store = configureStore({
  reducer: {
    establishmentAccess: establishmentAccessReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
